import { StringParam } from 'use-query-params';

const mapState = {
  i: StringParam,
  m: StringParam,
  view: StringParam,
};

export default mapState;
